var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.external && _vm.href)?_c('nuxt-link',{attrs:{"to":_vm.href},domProps:{"textContent":_vm._s(_vm.title)}}):_c('a',{attrs:{"rel":"noopener","target":"_blank","href":_vm.href},domProps:{"textContent":_vm._s(_vm.title)}})}
var staticRenderFns = []

export { render, staticRenderFns }